<template>
  <div class="datepicker-container text-dark">
    <div class="datepicker-panel no-select box-shadow"
         :class="{ 'no_weekends': !weekends }"
         id="datepicker-panel">
      <div id="calBoxContainer">
        <div id="calBox" class="datepicker-cells">
          <ul class="week-row">
            <li v-for="day in weekdays"
                :key="day"
                class="datepicker-cell">{{ day }}
            </li>
          </ul>
          <div v-for="weeks in datesInWeeks" class="week-row">
            <div v-for="date in weeks.dates" :class="'datepicker-cell ' + date.dayClass">
              <v-touch @tap="setDate(date)">
                <span v-if="date.show"
                      class="number"
                      :class="[{isToday: date.isToday, active: date.isSelected}]">
                      {{ date.showDate }}
                  </span>
                <span v-else
                      class="number"
                      :class="[{isToday: date.isToday, active: date.isSelected}]">
                      {{ date.showDate }}
                </span>
              </v-touch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment' // eslint-disable-line no-unused-vars
import {mixin as clickaway} from 'vue-clickaway'

export default {
  name: 'DateSelector', // datepicker is not acceptable
  mixins: [clickaway],
  props: {
    date: {
      default: () => moment()
    },
    theCalendarDate: {
      default: () => moment()
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    today () {
      return moment().format('YYYY-MM-DD')
    },
    weekdays () {
      let days = []
      for (let i = 1; i <= 7; i++) {
        days.push(moment().isoWeekday(i).format('ddd'))
      }
      return days
    },
    weeks () {
      let week = []
      const date = moment(this.date).utc().date(1)
      let daysInMonth = moment(this.date).daysInMonth()
      week.push(moment(date).isoWeek())
      for (let i = 1; i <= daysInMonth; i++) {
        let thisDate = moment(date).date(i)
        let weekNum = thisDate.isoWeek()
        if (week[week.length - 1] !== weekNum) {
          week.push(weekNum)
        }
      }
      return week
    },
    datesInWeeks () {
      let weeks = []
      const date = moment(this.date).utc()
      let startOfMonth = moment(date.startOf('month'))
      let weeksInMonth = this.weeks.length
      let startWeek = moment(startOfMonth).isoWeek()
      let thisMonth = moment(date).month()
      for (let i = 0; i < weeksInMonth; i++) {
        let weekNum = startWeek + i
        let dates = []
        for (let j = 1; j <= 7; j++) {
          let thisDate = moment(date).isoWeek(weekNum).isoWeekday(j)
          if (thisMonth !== moment(date).isoWeek(weekNum).isoWeekday(j).month()) {
            dates.push({
              show: false,
              showDate: '&nbsp;',
              dayClass: 'hide'
            })
          } else {
            dates.push({
              show: true,
              date: thisDate.format('YYYY-MM-DD'),
              showDate: thisDate.format('D'),
              dayOfWeek: thisDate.isoWeekday(),
              week: thisDate.isoWeek(),
              isToday: this.isTodayDate(thisDate),
              isSelected: this.isCurrentDate(thisDate),
              id: thisDate.format('D'),
              dayClass: 'd_' + thisDate.isoWeekday()
            })
          }
        }
        weeks.push({
          'week': weekNum,
          'dates': dates
        })
      }
      return weeks
    }
  },
  methods: {
    closeDatePicker () {
      this.active = false
    },
    isCurrentDate (date) {
      const datePickerDate = moment(this.theCalendarDate).format('YYYY-MM-DD')
      const theDate = moment(date).format('YYYY-MM-DD')
      return theDate === datePickerDate
    },
    isTodayDate (date) {
      return moment(date).format('Y-MM-DD') === moment().format('YYYY-MM-DD')
    },
    setDate (date) {
      this.$emit('changed', moment(date.date).format('YYYY-MM-DD'))
    }
  }
}

</script>


<style scoped>

@import '../../assets/css/variables.css';

.input-active {
  border-color: var(--blue)
}

.hide {
  opacity: 0;
}

.datepicker-container {
  width: 100%;
  min-height: 240px;
}

.datepicker-input input {
  height: 38px;
}

.datepicker-panel {
  z-index: 10000;
  min-height: 200px;
  flex-direction: column;
  display: flex;
  background: #fff;
  border-radius: 2px;
  line-height: 20px;
}

.datepicker-cells {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom: 5px;
}

.week-row {
  display: flex;
}

.datepicker-cell {
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  z-index: 1;
  flex: 1;
}

.datepicker-cell.hide {
  cursor: default;
}

.datepicker-cell.hide span {
  cursor: default;
}

.no_weekends .datepicker-cell {
  flex: 1;
}

#headline {
  font-size: 20px;
}

.month-header .arrow {
  padding: 20px;
}

.month-header .center {
  margin: 20px 0;
}

.no_weekends .cal.weekdays .weekday:nth-child(6), .no_weekends .cal.weekdays .weekday:nth-child(7) {
  display: none;
}

.newMonth {
  color: var(--orange);
}

.isToday {
  font-weight: bold;
  color: var(--orange);
}

.number {
  line-height: 35px;
  width: 38px;
  text-align: center;
  border-radius: 50%;
  margin: auto;
  border: 1px solid transparent;
  display: block;
}

.active {
  background-color: var(--blue);
  color: white;
  display: block;
}

.cal-icon {
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 18px;
}

.fadeDown-enter-active {
  transition: all 0.15s ease;
  transform-origin: top;
}

.fadeDown-enter {
  opacity: 0;
  transform: scaleY(0);
}

.fadeDown-enter-to {
  opacity: 1;
  transform: scaleY(1);
}
</style>



// WEBPACK FOOTER //
// DatepickerMobile.vue?125fbdac